import "./ProgressMeter.css";

function clampPercent(value) {
  return Math.min(Math.max(Number(value) || 0, 0), 100);
}

function resolveMeterMode(value) {
  return value === "segments" ? "segments" : "overlay";
}

function resolveMeterNotation(value) {
  return value === "segments" ? "segments" : "cumulative";
}

function resolveLevelPercent(levels, index, notation) {
  const percent = clampPercent(levels[index]?.percent);

  if (notation === "segments") {
    return percent;
  }

  const previousPercent = index > 0 ? clampPercent(levels[index - 1]?.percent) : 0;
  return Math.max(0, percent - previousPercent);
}

function resolveFillClassName(level) {
  return [
    "progress-meter-fill",
    `tone-${level.tone ?? "good"}`,
    level.emphasis ? `emphasis-${level.emphasis}` : ""
  ].filter(Boolean).join(" ");
}

export function ProgressMeter({
  levels = [],
  mode = "overlay",
  notation = "cumulative",
  showTrack = true,
  widthPercent = 100
}) {
  const resolvedMode = resolveMeterMode(mode);
  const resolvedNotation = resolveMeterNotation(notation);

  return (
    <div
      class={[
        "progress-meter",
        `progress-meter--${resolvedMode}`,
        showTrack ? "progress-meter--with-track" : "progress-meter--trackless"
      ].join(" ")}
      role="img"
      style={{ width: `${clampPercent(widthPercent)}%` }}
    >
      <div class="progress-meter-track">
        {levels.map((level, index) => (
          <span
            key={level.key ?? `${level.tone}-${index}`}
            class={resolveFillClassName(level)}
            style={{
              "--progress-meter-target-width": `${
                resolvedMode === "segments"
                  ? resolveLevelPercent(levels, index, resolvedNotation)
                  : clampPercent(level.percent)
              }%`
            }}
          />
        ))}
      </div>
    </div>
  );
}
